import React, { useEffect, useId, useRef, useState } from 'react';
import { Wallet } from 'lucide-react';
import { useAccess } from '../../contexts/AccessContext';
import { useAuth } from '../../contexts/AuthContext';
import { walletApi } from '../../api/wallet';

function WalletDisclosure({ userId, language }) {
  const ar = language === 'ar', panelId = useId();
  const [open, setOpen] = useState(false), [data, setData] = useState(null);
  const [loading, setLoading] = useState(false), [error, setError] = useState('');
  const request = useRef(null);
  useEffect(() => () => request.current?.abort(), []);
  const toggle = async () => {
    if (open) {
      request.current?.abort(); request.current = null;
      setOpen(false); setData(null); setLoading(false); setError('');
      return;
    }
    setOpen(true); setLoading(true); setError('');
    const controller = new AbortController(); request.current = controller;
    try {
      const wallet = await walletApi.viewUser(userId, controller.signal);
      if (!controller.signal.aborted) setData(wallet);
    } catch (failure) {
      if (!controller.signal.aborted) setError(failure.message);
    } finally { if (!controller.signal.aborted) setLoading(false); }
  };
  const currencies = new Map((data?.currencies || []).map(currency => [currency.code, currency]));
  const codes = [...currencies.keys()];
  return <section className="chat-preview-wallet">
    <button type="button" className="chat-preview-wallet-toggle" aria-label={ar ? 'محفظة المستخدم' : 'User wallet'} title={ar ? 'محفظة المستخدم' : 'User wallet'} aria-expanded={open} aria-controls={panelId} onClick={toggle}>
      <Wallet size={18}/>
    </button>
    {open && <div id={panelId} className="chat-preview-wallet-body">
      <p className="chat-detail-note">{ar ? 'عرض خاص للمصرّح لهم · الأرصدة الحالية' : 'Authorized access · Current balances'}</p>
      {loading && <p role="status">{ar ? 'جارٍ تحميل المحفظة…' : 'Loading wallet…'}</p>}
      {error && <p role="alert">{error}</p>}
      {data && <dl>{codes.map(code => {
        const currency = currencies.get(code);
        return <div key={code}>
          <dt>{currency?.iconUrl && <img src={currency.iconUrl} alt="" width={22} height={22}/>}<span>{(ar ? currency?.nameAr : currency?.nameEn) || code}</span></dt>
          <dd>{Number(data.balances?.[code] || 0).toLocaleString(ar ? 'ar' : 'en')}</dd>
        </div>;
      })}</dl>}
    </div>}
  </section>;
}

export default function ProfileWallet({ userId, language }) {
  const { hasPermission, loading } = useAccess();
  const { currentUserId } = useAuth();
  if (loading || !userId || !hasPermission('USERS_WALLET_VIEW')) return null;
  // Remount on account/target changes; revoked access unmounts and aborts the read.
  return <WalletDisclosure key={`${currentUserId}:${userId}`} userId={userId} language={language}/>;
}
